import { Box } from "@stenajs-webui/core";
import {
  BreadCrumbs,
  CardBody,
  CardHeader,
  FlatButton,
  Icon,
  stenaBusinessAgreement,
  stenaInfoCircle,
  stenaUserCircle,
} from "@stenajs-webui/elements";
import { Popover } from "@stenajs-webui/tooltip";
import * as React from "react";
import { Crumb } from "@/components/bread-crumbs/Crumb";
import { PageHeader } from "@/components/page-header/PageHeader";
import { routeFactory } from "../../../RouteFactory";

import { ZIndex } from "@/lib/utils/ZIndexEnum";
import { CustomerBaseInformation } from "@/features/product-and-price/info-boxes/customer/CustomerBaseInformation";
import { HeadAgreementInfoCardBody } from "@/features/product-and-price/info-boxes/head-agreement/head-agreement-info-pair-box/HeadAgreementInfoCardBody";
import {
  HeadAgreementStatusCode,
  ReportScreenCustomerFragment,
  ReportScreenHeadagreementFragment,
} from "@/gql/graphql";

interface Props {
  loading: boolean;
  customerId: string;
  headAgreementId: string;
  customer: ReportScreenCustomerFragment | null;
  headAgreement: ReportScreenHeadagreementFragment | null;
  reportType?: string;
  name?: string;
}

export const ReportHeader: React.FC<Props> = ({
  loading,
  customerId,
  headAgreementId,
  customer,
  reportType,
  headAgreement,
}) => {
  return (
    <PageHeader
      title={
        reportType
          ? `Create ${reportType} - ${customer?.name || ""} (${customerId})`
          : "Create report"
      }
      loading={loading}
      contentLeft={
        <Popover
          trigger={"click"}
          zIndex={2}
          appendTo={document.body}
          renderTrigger={(props) => (
            <FlatButton leftIcon={stenaInfoCircle} {...props} />
          )}
        >
          <Box zIndex={ZIndex.highest} minWidth={"490px"}>
            <CardHeader
              text={"Header agreement"}
              headingLevel={"h2"}
              contentLeft={<Icon icon={stenaBusinessAgreement}></Icon>}
            />
            {headAgreement && (
              <HeadAgreementInfoCardBody
                headAgreement={{
                  id: headAgreementId,
                  headAgreementNumber: headAgreement?.headAgreementNumber,
                  valid: headAgreement?.valid,
                  hasSomeRouteAgreementsWithMultiLeg:
                    headAgreement?.multiLegAgrRoutes?.length > 0 || false,
                  name: headAgreement?.name,
                  statusCode: HeadAgreementStatusCode.Active,
                }}
              />
            )}
            {customer && (
              <>
                <CardHeader
                  text={"Customer"}
                  headingLevel={"h2"}
                  contentLeft={<Icon icon={stenaUserCircle}></Icon>}
                />
                <CardBody
                  flexDirection={"row"}
                  flexWrap={"wrap"}
                  variant={"compact"}
                >
                  <CustomerBaseInformation
                    custIndex={customer?.custIndex || ""}
                    custNo={customer?.custNo}
                    custStatNo={customer?.statisticalGroupingId}
                    custInvoiceCurrency={customer.invoiceCurrency.code}
                  />
                </CardBody>
              </>
            )}
          </Box>
        </Popover>
      }
      breadcrumbs={
        <BreadCrumbs>
          <Crumb
            label={customer?.breadCrumbName ?? ""}
            path={routeFactory.productAndPrice.customer.customer({
              customerId,
            })}
          />
          <Crumb
            label={String(headAgreement?.headAgreementNumber ?? "")}
            path={routeFactory.productAndPrice.customer.customerHeadAgreement({
              customerId,
              headAgreementId: headAgreement?.id ?? "",
            })}
          />
          <Crumb label={"Create report"} />
        </BreadCrumbs>
      }
    />
  );
};
